<p-table [value]="ruleData" responsiveLayout="scroll">
    <ng-template pTemplate="header" let-rule>
        <tr>
            @if(!showHideDefaultData){
            <th>Rule No.</th>
            }
            <th>Choice</th>
            <th>Filter</th>
            <th>Operator</th>
            <th style="max-width: 300px;">Value</th>
            <th class="action p-text-right" *ngIf="!isDisabled">Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rule let-index="rowIndex">
        <!-- @if(isMainModule){ -->

        <tr *ngIf="(isMainModule==rule.isMainModule && showHideDefaultData) || !showHideDefaultData">
            @if(!showHideDefaultData){
            <td>#{{index + 1}}</td>
            }
            <td>{{rule.choice?.name}}</td>
            <td>
                <span *ngIf="rule?.module || rule.objectName">{{rule?.module?.name ??
                    rule?.objectName}}</span>
                <span *ngIf="rule?.isMainModule && rule.template">({{rule.template?.templateName}})</span>
                <span *ngIf="rule.module || rule?.objectName">: </span> {{ rule.filter?.parentLabelName ? rule.filter?.parentLabelName + ': ' : ''}}{{rule.filter?.labelname ?? rule.filter?.field}}
            </td>
            <td>{{rule.operator?.name}}</td>
            <td style="max-width: 300px;">
                <ng-container>
                    <span *ngIf="rule.dataTypeWithOperator?.DataType == 'Boolean'">
                        {{rule.value?.name}}
                    </span>
                    <!-- String -->
                    <ng-container *ngIf="rule.dataTypeWithOperator?.DataType == 'String'">
                        <span *ngIf="rule.filter?.valueDataType == 'String'">{{rule.value}}</span>
                        <span *ngIf="rule.filter?.valueDataType == 'User'">
                            <ng-container *ngFor="let s of rule.value; let i = index;">
                                {{i>0?',':''}} {{s?.name}}
                            </ng-container>
                        </span>
                        <span *ngIf="rule.filter?.valueDataType == 'Year'">
                            {{rule.value | date: 'yyyy'}}</span>
                        <span *ngIf="rule.filter?.valueDataType == 'TreeSelect'">
                            {{rule.value?.label}}</span>
                        <span *ngIf="rule.filter?.valueDataType == 'AutoCompleteDropdown' && (checkArray.isArray(rule.value))">
                            <ng-container *ngFor="let s of rule.value; let i = index;">
                                {{i>0?',':''}} {{s?.name}}
                            </ng-container>
                        </span>
                        <span *ngIf="rule.filter?.valueDataType == 'AutoCompleteDropdown' && (!checkArray.isArray(rule.value))">
                            {{rule.value?.name ?? rule.value?.item2 ?? rule.value}}
                        </span>
                    </ng-container>
                    <!-- Number -->
                    <ng-container *ngIf="rule.dataTypeWithOperator?.DataType == 'Number' || rule.dataTypeWithOperator?.DataType == 'Decimal' || rule.dataTypeWithOperator?.DataType == 'Money'">
                        <span *ngIf="rule.filter?.valueDataType == 'Number' || rule.filter?.valueDataType == 'Decimal'">
                            {{ rule?.compareWithField ? (rule?.comparisonCriteriaParentLabel ? rule.comparisonCriteriaParentLabel+': ' : '') + rule?.comparisonCriteriaLabel : rule.value}}
                        </span>
                    </ng-container>
                    <!-- Distance -->
                    <ng-container *ngIf="rule.dataTypeWithOperator?.DataType == 'Distance'">
                        <span *ngIf="rule.filter?.valueDataType == 'Distance'">
                            Address: {{rule.value?.address}},
                            Radius: {{rule.value?.radius}}
                            {{rule.value?.radius > 2 ? 'miles':'mile'}}
                        </span>
                    </ng-container>
                    <!-- DateTime -->
                    <ng-container *ngIf="rule.dataTypeWithOperator?.DataType == 'DateTime'">
                        <span *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'
                            && rule.dataTypeWithOperator?.Operator == 'Is'">
                            <!-- {{rule.value | date:'MM/dd/yyyy'}} -->
                            {{rule.value2?.label}}
                        </span>
                        <span *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'
                            && (rule.dataTypeWithOperator?.Operator != 'Is' || (rule.dataTypeWithOperator?.Operator == 'Is' && rule.value2?.code == 'custom'))">
                            {{rule.value | date:'MM/dd/yyyy'}}
                        </span>
                        <span *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'">
                            {{rule.value[0] | date:'MM/dd/yyyy'}} to
                            {{rule.value[1] | date:'MM/dd/yyyy'}}
                        </span>
                    </ng-container>
                    <!-- Time -->
                    <ng-container *ngIf="rule.dataTypeWithOperator?.DataType == 'Time'">
                        <span *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'">
                            {{rule.value | onlyTime}}
                        </span>
                        <span *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'">
                            {{rule.value[0] | onlyTime}} to
                            {{rule.value[1] | onlyTime}}
                        </span>
                    </ng-container>
                    <!-- Enum -->
                    <span *ngIf="rule.dataTypeWithOperator?.DataType == 'Enum'">
                        <ng-container
                            *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed!='No_Value'">
                            <ng-container *ngIf="rule?.filter?.valueDataType == 'DropdownList' && rule.value">
                                {{rule.value?.name}}
                            </ng-container>
                            <ng-container
                                *ngIf="rule?.filter?.valueDataType == 'MultiSelect' && rule.value">
                                <ng-container *ngFor="let s of rule.value; let i = index;">
                                    {{i>0?',':''}} {{s?.name}}
                                </ng-container>
                            </ng-container>
                            <ng-container
                                *ngIf="rule?.filter?.valueDataType == 'MultiSelectAPI' && rule.value">
                                <ng-container *ngFor="let s of rule.value; let i = index;">
                                    {{i>0?',':''}} {{s?.name}}
                                </ng-container>
                            </ng-container>
                            <ng-container
                                *ngIf="rule?.filter?.valueDataType == 'Country' && rule.value">
                                <!-- <ng-container *ngFor="let s of rule.value; let i = index;">
                                {{s?.parent?.parent?.label ?? ''}} {{s?.parent?.label ? ',':''}}
                                {{s?.parent?.label ?? ''}} {{s?.label ? ',':''}}
                                {{s?.label ?? ''}}
                                </ng-container> -->
                                {{rule.value?.name}}
                            </ng-container>
                            <span *ngIf="rule.filter?.valueDataType == 'User'">
                                <ng-container *ngFor="let s of rule.value; let i = index;">
                                    {{i>0?',':''}} {{s?.name}}
                                </ng-container>
                            </span>
                            <ng-container *ngIf="rule.filter?.valueDataType == 'TreeSelect' && rule.filter?.field.toLowerCase() == 'territoryname'">
                                <span *ngIf="rule?.value?.parent">
                                            Parent: {{rule?.value?.parent?.label}},
                                            Name: {{rule.value.label}}
                                        </span>
                                <span *ngIf="!rule?.value?.parent">
                                            Parent: {{rule?.value?.label}},
                                            Name:
                                        </span>
                            </ng-container>
                            <ng-container *ngIf="rule.filter?.valueDataType == 'TreeSelect' && rule.filter?.field.toLowerCase() != 'territoryname'">
                                <ng-container *ngFor="let s of rule.value; let i = index;">
                                    {{i>0?',':''}} {{s?.name}}
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed=='No_Value'">
                            <span>{{rule.value}}</span>
                        </ng-container>
                    </span>
                </ng-container>
                <!-- Between_Value -->
                <ng-container *ngIf="(rule.value2 || rule.value2>=0) && rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'">
                    <span *ngIf="rule.dataTypeWithOperator?.DataType == 'Boolean'">&nbsp; to &nbsp;
                        {{rule.value2?.name}}</span>
                    <span *ngIf="rule.dataTypeWithOperator?.DataType == 'String'">&nbsp; to &nbsp;
                        {{rule.value2}}</span>
                    <span *ngIf="rule.dataTypeWithOperator?.DataType == 'Number'">&nbsp; to &nbsp;
                        {{rule.value2}}</span>
                    <span *ngIf="rule.dataTypeWithOperator?.DataType == 'Decimal'">&nbsp; to &nbsp;
                        {{rule.value2}}</span>
                    <span *ngIf="rule.dataTypeWithOperator?.DataType == 'Money'">&nbsp; to &nbsp;
                            {{rule.value2}}</span>
                </ng-container>
            </td>
            <td class="action p-text-right" *ngIf="!isDisabled">
                <span [ngClass]="{'saved-search-disabled': isDisabled || !rule.canEdit}" class="btnBars p-mr-0" (click)="editRule(rule, index)" *ngIf="!showHideDefaultData">
                    <i class="pi pi-pencil"></i>
                </span>
                <span [ngClass]="{'saved-search-disabled': isDisabled || !rule.canEdit}" class="btnBars p-mr-0" (click)="removeRule(rule, index)">
                    <i class="pi pi-trash"></i>
                </span>
            </td>
        </tr>
    </ng-template>
</p-table>

@if(!showHideDefaultData){

<div *ngIf="!isDisabled" class="combine-rules-wrapper">
    <h6 class="combine-rules-header">
        Combine Multiple Rules
        <div class="combine-rules-options">
            <span *ngIf="!isCombinational" (click)="addCombineRules()" class="btnBars p-mr-0" pTooltip="Combine Multiple Rules" tooltipPosition="top">
                <i class="pi pi-plus"></i>
            </span>
            <span *ngIf="isCombinational" (click)="regenerateRuleCombination()" class="btnBars p-mr-0" pTooltip="Reset Combine Rules" tooltipPosition="top">
                <i class="pi pi-refresh"></i>
            </span>
            <span *ngIf="isCombinational" (click)="clearCombineRules()"  class="btnBars p-mr-0" pTooltip="Clear Combined Rules" tooltipPosition="top">
                <i class="pi pi-trash"></i>
            </span>
        </div>
    </h6>

    <div *ngIf="isCombinational" class="p-grid p-mt-2">
        <div class="p-col-8">
            <textarea *ngIf="!isEditCombineRule" type="text" [(ngModel)]="combinedRulesValue" pInputText [disabled]="true" placeholder="Enter Rules Combination"></textarea>
            <textarea *ngIf="isEditCombineRule" type="text" (keydown.enter)="$event.preventDefault()" [(ngModel)]="combinedRulesValueEdit" pInputText placeholder="Enter Rules Combination"></textarea>
            <small *ngIf="combineRulesErrorMsg" style="color: red;" class="saved-search-rule-error">{{combineRulesErrorMsg}}</small>
        </div>
        <div class="p-col-4">
            <div class="combine-rules-options">
                <span *ngIf="!isEditCombineRule" (click)="editCombineRule()" class="btnBars p-mr-0 p-text-info" pTooltip="Edit Combined Rules" tooltipPosition="top">
                    <i class="pi pi-pencil"></i>
                </span>
                <span *ngIf="isEditCombineRule" (click)="saveCombineRules()" class="btnBars p-mr-0" pTooltip="Save Combined Rules" tooltipPosition="top">
                    <i class="pi pi-check"></i>
                </span>
                <span *ngIf="isEditCombineRule" (click)="cancelCombineRules()" class="btnBars p-mr-0" pTooltip="Cancel" tooltipPosition="top">
                    <i class="pi pi-times"></i>
                </span>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isDisabled && isCombinational" class="combine-rules-wrapper">
    <h6 class="combine-rules-header">
        Added Rules Combination
    </h6>
    <div class="p-grid p-mt-2">
        <div class="p-col-8">
            <strong class="p-ml-3">{{ combinedRulesValue }}</strong>
        </div>
    </div>
</div>
}